<script setup>
const props = defineProps({
    socialLinks: {
        type: Array,
    },
})

const getBackgroundColor = (platformId) => {
    switch (platformId) {
        case 'kick':
            return 'bg-[#53fc18]'
        case 'twitter':
            return 'bg-x'
        default:
            return `bg-${platformId}`
    }
}

const getTextColor = (platformId) => {
    switch (platformId) {
        case 'kick':
            return 'text-black'
        case 'twitter':
            return 'text-slate-100'
        case 'patreon':
            return 'text-slate-950'
        default:
            return 'text-slate-100'
    }
}
</script>

<template>
    <div class="mt-4">
        <div class="inline-flex items-center rounded border border-slate-100 overflow-hidden">
            <div class="px-3.5 py-2.5 text-xs font-semibold uppercase tracking-wide border-r border-slate-100">
                Social Links
            </div>

            <a
                v-for="socialLink in props.socialLinks"
                :key="socialLink._id"
                :href="socialLink.link"
                target="_blank"
                class="group flex items-center justify-center border-l border-slate-100 first:border-l-0 px-2.5 py-2.5 cursor-pointer transition-colors duration-150 hover:bg-slate-50"
            >
                <div
                    :class="`
                        btn-sm relative h-[28px] w-[28px] flex items-center justify-center
                        ${getBackgroundColor(socialLink.tpid)}
                        ${getTextColor(socialLink.tpid)}
                        transition-opacity duration-150 group-hover:opacity-80
                    `"
                >
                    <div class="group-hover:opacity-0 transition-opacity duration-150">
                        <AppIcon
                            v-if="socialLink.tpid !== 'kick'"
                            :name="['twitter', 'x'].includes(socialLink.tpid) ? 'x-twitter' : socialLink.tpid"
                            class="h-[14px] w-[14px] shrink-0 group-hover:text-white transition-colors duration-150"
                        />
                        <div v-else class="font-bold">
                            <svg
                                class="h-[14px] w-[14px] fill-current"
                                xmlns="http://www.w3.org/2000/svg"
                                fill="none"
                                viewBox="0 0 16 16"
                            >
                                <path
                                    d="M3 2h3.75v3H8V3.714h1.25V2H13v3.857h-1.25v1.286H10.5v1.714h1.25v1.286H13V14H9.25v-1.714H8V11H6.75v3H3V2z"
                                />
                            </svg>
                        </div>
                    </div>

                    <div class="absolute opacity-0 group-hover:opacity-100 transition-opacity duration-150">
                        <AppIcon
                            name="arrow-up-right-from-square"
                            class="h-[11px] w-[11px] shrink-0 text-slate-300 group-hover:text-white transition-colors duration-150"
                        />
                    </div>
                </div>
            </a>
        </div>
    </div>
</template>
